import {useEffect, useRef, useState} from "react"

// Same-origin, versioned document preserves the tested calculator's CSS and lifecycle.
export default function CalculatorFrame() {
    const frame = useRef(null)
    const [height, setHeight] = useState(1000)
    const [unavailable, setUnavailable] = useState(false)

    useEffect(() => {
        let ready = false
        const receiveSize = event => {
            if (event.origin !== window.location.origin || event.source !== frame.current?.contentWindow) return
            if (event.data?.type !== "fleeka-calculator-size-v1") return
            const nextHeight = event.data.height
            if (!Number.isFinite(nextHeight) || nextHeight < 300 || nextHeight > 6000) return
            ready = true
            setUnavailable(false)
            setHeight(Math.ceil(nextHeight))
        }
        window.addEventListener("message", receiveSize)
        const timeout = window.setTimeout(() => {
            if (!ready) setUnavailable(true)
        }, 12000)
        return () => {
            window.removeEventListener("message", receiveSize)
            window.clearTimeout(timeout)
        }
    }, [])

    return (
        <div id="qq-trip-calculator" style={{width: "100%", background: "#f6f7f9"}}>
            <iframe
                ref={frame}
                title="Калькулятор стоимости междугородней поездки Флика"
                src="/calculator/fleeka-widget-16.html"
                loading="eager"
                scrolling="no"
                referrerPolicy="strict-origin-when-cross-origin"
                style={{display: "block", width: "100%", height, border: 0}}
            />
            {unavailable && <p style={{padding: 24, textAlign: "center"}}>
                Калькулятор загружается дольше обычного. <a href="/calculator-test.html">Открыть отдельно</a> или <a href="tel:+79507007071">позвонить</a>.
            </p>}
        </div>
    )
}
